
import Vue from "vue";

export default Vue.extend({
  name: "RecruiterAiInterviewDetailsCard",
  props: {
    showGuidelines: {
      type: Boolean,
      default: true
    },
    showTeamsInfo: {
      type: Boolean,
      default: false
    },
    transcriptVia: {
      type: String,
      default: "Microsoft Teams"
    },
    meetingLink: {
      type: String,
      default: ""
    },
    meetingId: {
      type: String,
      default: ""
    },
    meetingJoinId: {
      type: String,
      default: ""
    },
    meetingPasscode: {
      type: String,
      default: ""
    },
    resultLabel: {
      type: String,
      default: "View AI Interview Result"
    },
    showResultAction: {
      type: Boolean,
      default: true
    },
    roleValue: {
      type: String,
      default: ""
    },
    formatValue: {
      type: String,
      default: ""
    },
    durationValue: {
      type: String,
      default: ""
    },
    scheduledAt: {
      type: String,
      default: ""
    },
    interviewTitle: {
      type: String,
      default: "Interview Details"
    },
    resultDisabled: {
      type: Boolean,
      default: false
    },
    resultStatusText: {
      type: String,
      default: ""
    },
    showFinalReportAction: {
      type: Boolean,
      default: false
    },
    showRescheduleAction: {
      type: Boolean,
      default: false
    },
    rescheduleActionLabel: {
      type: String,
      default: "Reschedule Interview"
    },
    rescheduleActionDisabled: {
      type: Boolean,
      default: false
    },
    rescheduleActionLoading: {
      type: Boolean,
      default: false
    },
    finalReportActionLabel: {
      type: String,
      default: "Generate Final Report"
    },
    finalReportActionDisabled: {
      type: Boolean,
      default: false
    },
    finalReportActionLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parsedDate(): Date | null {
      if (!this.scheduledAt) return null;
      const parsed = new Date(this.scheduledAt);
      return isNaN(parsed.getTime()) ? null : parsed;
    },
    calendarMonth(): string {
      return this.parsedDate
        ? this.parsedDate.toLocaleString(undefined, { month: "short" }).toUpperCase()
        : "--";
    },
    calendarDay(): string {
      return this.parsedDate ? String(this.parsedDate.getDate()) : "--";
    },
    formattedDate(): string {
      return this.parsedDate
        ? this.parsedDate.toLocaleDateString(undefined, {
            day: "numeric",
            month: "long",
            year: "numeric"
          })
        : "Not scheduled";
    },
    formattedTimeWithZone(): string {
      return this.parsedDate
        ? this.parsedDate.toLocaleString(undefined, {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
            timeZoneName: "short"
          })
        : "--";
    },
    topDetails(): { label: string; value: string }[] {
      return [
        { label: "Role", value: this.roleValue || "-" },
        { label: "Format", value: this.formatValue || "-" },
        { label: "Duration", value: this.durationValue || "-" }
      ];
    }
  },
  data() {
    return {
      msTeamsLogo: require("@/assets/images/interviews/ms_teams_logo.png"),
      skills: ["HTML", "CSS", "SQL", "Python", "JavaScript", "C#", "Ruby", "Go"]
    };
  }
});
